import React, { useState, useRef } from 'react';
import { sendMessage } from '../controller/client/PartyClient';
import { Form } from 'antd';
import { IPartyForUser, TUserId, IMessage, TMessageId } from '../PartyClientResponse';
import autoscroll from 'autoscroll-react';
import { getIdToken } from '../controller/PartyDB';
import { MAX_MESSAGES_SHOWN } from './party/AppConstants';
import { useAppState } from '../state/AppState';
import Picker from 'emoji-picker-react';
import MessageInput from './messages/MessageInput';
import MessageText from './messages/MessageText';

class MessageList extends React.Component<{ items: (IMessage & { id: string })[] }> {
  render() {
    const { items, ...props } = this.props;
    return (
      <div className='area-chat' {...props}>
        {this.props.items.map((message) => {
          return (
            <div
              style={{
                padding: 4,
                display: 'flex',
                alignItems: 'center',
              }}
              key={message.id}>
              <img
                style={{
                  margin: '4px 8px 4px 0',
                  alignSelf: 'flex-start',
                  width: 12,
                  height: 12,
                  borderRadius: '50%',
                }}
                src={message.creatorPhotoUrl}
                alt='avatar'
              />
              <span
                className='message-sender'
                style={{
                  marginRight: '1em',
                  fontWeight: 'bold',
                  whiteSpace: 'nowrap',
                  alignSelf: 'flex-start',
                }}>
                {message.creatorName}
              </span>
              <span>
                <MessageText text={message.text} />
              </span>
              {/* <span>
                {parse(
                  linkifyStr(message.text, {
                    defaultProtocol: 'https',
                    className: 'message-link',
                    tagName: 'a',
                  })
                )}
              </span> */}
            </div>
          );
        })}
      </div>
    );
  }
}

const ScrollableMessageList = autoscroll(MessageList);

const PartyMessages = ({ party }: { party: IPartyForUser }) => {
  const [inputValue, setInputValue] = useState<string>('');
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState<boolean>(false);
  const { user, currentArea } = useAppState();
  const [eagerMessages, setEagerMessages] = useState<Partial<{ [key in TMessageId]: IMessage }>>(
    {}
  );
  const [form] = Form.useForm();

  const areaMessages = [
    ...Object.entries(eagerMessages || {})
      .filter(
        (m) => !Object.values(party.messages || {}).find((msg) => msg?.localId === m[1]?.localId)
      )
      .map((m) => ({
        ...m[1],
        id: m[1]?.localId,
      })),
    ...Object.entries(party.messages || {}).map((m) => ({
      ...m[1],
      id: eagerMessages[m[0] as TMessageId]?.localId || m[0],
    })),
  ]
    // @ts-ignore
    .sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1))
    // uncomment this to scope messages to areas again (also update partycontroller)
    // message scope should be null if party-wide
    .filter((message) => message.scope === currentArea || !message.scope)
    .filter((_, i, fullList) => i >= fullList.length - MAX_MESSAGES_SHOWN);

  return (
    <div className='chat-container'>
      <ScrollableMessageList items={areaMessages} />
      <Form
        form={form}
        style={{
          display: 'flex',
          flexGrow: 0,
          maxHeight: 60,
          justifySelf: 'flex-end',
        }}
        name='message-input'
        onFinish={async () => {
          if (!inputValue) {
            return;
          }
          setInputValue('');
          const localId = String(100000 * Math.random()) as TMessageId;
          try {
            setEagerMessages((messages) => ({
              ...messages,
              [localId]: {
                creatorId: user?.uid || ('' as TUserId),
                creatorName: user?.displayName || '',
                creatorPhotoUrl: user?.avatarUrl || user?.photoURL || '',
                text: inputValue,
                scope: null,
                createdAt: Date.now(),
                localId,
              },
            }));
            await sendMessage({
              idToken: await getIdToken(),
              partyKey: party.key,
              text: inputValue,
              localId,
            });
          } catch (err) {
            setEagerMessages(({ [localId]: msgToRemove, ...messages }) => messages);
            console.error(err);
          }
        }}>
        <div style={{ display: 'flex', width: '100%' }}>
          <div
            style={{
              display: 'inline-flex',
              position: 'relative',
              userSelect: 'none',
              paddingRight: 10,
            }}>
            <div
              style={{ display: 'flex', width: 40, height: 40 }}
              onClick={() => setShowEmojiPicker((val) => !val)}>
              <img
                alt='emoji'
                className='chat-send'
                width={40}
                src='/icons/emoji-add-svgrepo-com-line.svg'></img>
            </div>
            <div
              style={{
                position: 'absolute',
                bottom: '120%',
                display: showEmojiPicker ? 'initial' : 'none',
              }}>
              <Picker
                onEmojiClick={(e, emojiObject) => {
                  setInputValue((val) => {
                    if (val) {
                      return `${val} ${emojiObject.emoji}`;
                    }
                    return emojiObject.emoji;
                  });
                  setShowEmojiPicker(false);
                  inputRef.current?.focus();
                }}
                disableSearchBar
              />
            </div>
          </div>
          <MessageInput inputRef={inputRef} inputValue={inputValue} setInputValue={setInputValue} />
          {/* required to make enter submit the form */}
          <input type='submit' style={{ display: 'none' }} />{' '}
          <img
            alt='Send'
            className='chat-send'
            width={40}
            src='/icons/Send.svg'
            onClick={() => form.submit()}></img>
        </div>
      </Form>
    </div>
  );
};

export default PartyMessages;
